/* src/app/app.component.scss */
#emulatingBanner {
  position: absolute;
  bottom: 0;
  left: 6.25rem;
  width: calc(100% - 7.25rem);
  padding: 0.5rem;
  background-color: #1E31BF;
  color: #FFFFFF;
  text-align: center;
  font-family: "PoppinsSemi Bold";
  font-size: 1rem;
  z-index: 999999 !important;
  border-top: 0.0625rem solid #020F6E;
}
#emulatingBanner a {
  cursor: pointer;
  text-decoration: underline;
  color: #FFFFFF;
}
#emulatingBanner a:hover {
  color: #757575;
}
#emulatingBanner span.emulated-username {
  font-family: "PoppinsExtra Bold";
  color: #FFFFFF;
}
:root {
  height: 100vh;
  --app-height: 100%;
}
main {
  height: 100vh;
}
main.content-container {
  width: 100vw;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  transition: all 300ms ease-in-out;
}
main.content-container.with-menu {
  margin-left: 6.25rem;
  width: calc(100vw - 6.25rem);
  background-color: #E6EAFF;
  transition: all 300ms ease-in-out;
}
main.content-container.agency-manager-locked {
  pointer-events: none;
  -webkit-user-select: none;
  user-select: none;
}
.agency-manager-locked-menu {
  pointer-events: none;
  -webkit-user-select: none;
  user-select: none;
}
body.gu-unselectable .gu-mirror {
  cursor: grabbing !important;
}
@media (prefers-color-scheme: dark) {
  main.content-container.dark-mode.with-menu {
    background-color: #15161c !important;
  }
  .menu.dark-mode {
    background-color: #222222 !important;
  }
}
.menu {
  position: fixed;
  box-shadow: 0rem 0.625rem 0.625rem rgba(0, 0, 0, 0.13), 0rem 0.875rem 1.75rem rgba(0, 0, 0, 0.12);
  opacity: 1;
  background: #FFFFFF;
  border-radius: 0.25rem;
  z-index: 10040004 !important;
  min-width: 14rem;
  width: auto;
  max-width: 22rem;
  max-height: 26rem;
  transition: opacity 300ms cubic-bezier(0, 0.6, 0.4, 1);
  overflow-y: auto;
  overflow-x: hidden;
}
.menu.open {
  opacity: 1;
  transition: opacity 300ms cubic-bezier(0, 0.6, 0.4, 1);
}
.menu.group-chat-menu {
  width: 11.4375rem;
  min-width: 11.4375rem;
  padding: 0.5rem 0;
}
/*# sourceMappingURL=app.component.css.map */
